import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/download.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/sav.svg';
var SIZES = {
  S: 'btn-sm',
  M: '',
  L: 'btn-lg'
};
var TYPES = {
  primary: 'btn-dark',
  secondary: '',
  transparent: 'btn-transparent'
};
export default {
  name: 'Cta',
  props: {
    svg: {
      type: String,
      default: ''
    },
    textBtn: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'transparent'].includes(value);
      }
    },
    url: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'M'
    }
  },
  computed: {
    hasTextButton: function hasTextButton() {
      if (this.textBtn.length <= 0) {
        return false;
      }

      return true;
    },
    sizes: function sizes() {
      return SIZES;
    },
    types: function types() {
      return TYPES;
    }
  }
};